module.exports = __webpack_public_path__ + "img/banner_image1.4e746fd1.jpg";